module.exports = __webpack_public_path__ + "static/media/divinemercy.29716ed1.webp";